import { render } from "./ui-table-footer-item.vue?vue&type=template&id=eb762c64&ts=true"
import script from "./ui-table-footer-item.vue?vue&type=script&lang=ts"
export * from "./ui-table-footer-item.vue?vue&type=script&lang=ts"

import "./ui-table-footer-item.vue?vue&type=style&index=0&id=eb762c64&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__